import * as z from 'zod'

import {
  ScheduleFrequency,
  ScheduleItem,
  UpsertScheduleVars
} from '@/common/api/params/mediaAnalysisAutomation'

export const WEEKDAY_CHOICES: { name: string; value: string }[] = [
  { name: '月', value: 'mon' },
  { name: '火', value: 'tue' },
  { name: '水', value: 'wed' },
  { name: '木', value: 'thu' },
  { name: '金', value: 'fri' },
  { name: '土', value: 'sat' },
  { name: '日', value: 'sun' }
]

export const DAY_OF_MONTH_CHOICES: { name: string; value: number }[] = [1, 5, 10, 15, 20, 25].map(
  (d) => ({ name: `毎月${d}日`, value: d })
)

const baseMediaAnalysisAutomationSettingsSchema = z.object({
  frequency: z.enum(['daily', 'weekly', 'monthly']),
  weekdays: z.array(z.string()),
  dayOfMonth: z.number().nullable(),
  hour: z.number().min(0).max(23),
  minute: z.number().min(0).max(59),
  targetId: z.number().nullable()
})

export const buildMediaAnalysisAutomationSettingsSchema = (requiresTarget: boolean) =>
  baseMediaAnalysisAutomationSettingsSchema.superRefine((data, ctx) => {
    if (data.frequency === 'weekly' && data.weekdays.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['weekdays'],
        message: '実行曜日を1つ以上選択してください'
      })
    }
    if (data.frequency === 'monthly' && data.dayOfMonth == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['dayOfMonth'],
        message: '実行日を選択してください'
      })
    }
    if (requiresTarget && data.targetId == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['targetId'],
        message: '分析対象サイト名を選択してください'
      })
    }
  })

export type MediaAnalysisAutomationSettingsSchemaType = z.infer<
  typeof baseMediaAnalysisAutomationSettingsSchema
>

export const convertItemToSchema = (
  item: ScheduleItem
): MediaAnalysisAutomationSettingsSchemaType => ({
  frequency: (item.frequency ?? 'monthly') as ScheduleFrequency,
  weekdays: item.weekdays.length > 0 ? item.weekdays : ['mon'],
  dayOfMonth: item.day_of_month ?? 1,
  hour: item.hour ?? 4,
  minute: item.minute ?? 0,
  targetId: item.target_id
})

export const convertSchemaToUpsertVars = (
  siteId: number,
  analysisType: string,
  data: MediaAnalysisAutomationSettingsSchemaType,
  enabled: boolean
): UpsertScheduleVars => ({
  site_id: siteId,
  analysis_type: analysisType,
  enabled,
  frequency: data.frequency,
  weekdays: data.frequency === 'weekly' ? data.weekdays : null,
  day_of_month: data.frequency === 'monthly' ? data.dayOfMonth : null,
  hour: data.hour,
  minute: data.minute,
  target_id: data.targetId
})
